import { createSlice } from '@reduxjs/toolkit';

const RisqueDetailsDataSlice = createSlice({
    name: 'RisqueDetailsData',
    initialState: '',
    reducers: {
        setRisqueDetailsData: (state, action) => {
            return action.payload;
        },
        resetRisqueDetailsData: (state) => {
            return null;
        },
    },
});

export const { setRisqueDetailsData, resetRisqueDetailsData } = RisqueDetailsDataSlice.actions;
export default RisqueDetailsDataSlice.reducer;